import { create } from "zustand";

import { SelectedItem } from "@/3d/SelectedItem";
import { getDefaultRoomConfig, RoomConfig } from "./RoomConfig/RoomConfig";
import { DEFAULT_LIGHT_CONFIG, LightConfig } from "@/3d/LightConfig";

export const STEP = {
    ROOM_SETUP: "room setup",
    FURNITURE_PLACEMENT: "furniture placement",
} as const;

type Step = (typeof STEP)[keyof typeof STEP];
export type View = "2d" | "3d";

type DemoState = {
    step: Step;
    roomConfig: RoomConfig;
    selectedItem: SelectedItem | undefined;
    view: View;
    lightConfig: LightConfig[];

    isOrderDetailsOpen: boolean;
    setIsOrderDetailsOpen: (isOrderDetailsOpen: boolean) => void;

    isDragging: boolean;

    setIsDragging: (isDragging: boolean) => void;
    setSelectedItem: (selectedItem: SelectedItem | undefined) => void;
    setStep: (step: Step) => void;
    nextStep: () => void;
    setView: (view: View) => void;
    setRoomConfig: (roomConfig: RoomConfig) => void;
    setLightConfig: (lightConfig: LightConfig[]) => void;
};

export const useDemoState = create<DemoState>((set, get) => ({
    roomConfig: getDefaultRoomConfig(),
    step: STEP.ROOM_SETUP,
    view: "2d",
    lightConfig: DEFAULT_LIGHT_CONFIG,

    selectedItem: undefined,

    isDragging: false,

    isOrderDetailsOpen: false,

    setIsOrderDetailsOpen: (isOrderDetailsOpen: boolean) => {
        set({ isOrderDetailsOpen });
    },

    setIsDragging: (isDragging: boolean) => {
        set({ isDragging });
    },

    setSelectedItem: (selectedItem: SelectedItem | undefined) => {
        set({ selectedItem });
    },

    setStep: (step: Step) => {
        set({ step });
    },

    nextStep: () => {
        const step = get().step;
        if (step === STEP.ROOM_SETUP) {
            set({ step: STEP.FURNITURE_PLACEMENT, view: "3d" });
        }
    },

    setView: (view: View) => {
        set({ view });
    },

    setRoomConfig: (roomConfig: RoomConfig) => {
        set({ roomConfig });
    },

    setLightConfig: (lightConfig: LightConfig[]) => {
        set({ lightConfig });
    },
}));
